/* src/components/homeCssStyle.css */
import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid, Button } from "@mui/material";
import HomeImage from "../images/BG.svg";
import Playstore from "../images/playstore.svg";
import AppStore from "../images/appStore.svg";
import screen1 from "../images/homeImg1.svg";
import screen2 from "../images/homeImg2.svg";
import screen3 from "../images/homeImg3.svg";
// import screen4 from "../images/homeImg4.png";
import useStyles from "../css/homeStyle.js";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/homeCssStyle.css";


export default function Home() {
    const classes = useStyles;

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
    };

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                width: "100%",
                minHeight: "100vh",
                padding: 0,
                pb: { xs: 60, sm: 50, md: 10, lg: 10 },
                background: '#F6F4FE',
            }}
        >
            <Box id="Home"
                sx={{
                    width: "100%",
                    minHeight: "100vh",
                    padding: 0,
                    backgroundImage: `url(${HomeImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    minWidth: "100%",
                    pt: '64px',
                    // paddingBottom: '40%',
                }}
            >
                <Grid
                    container
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        pt: 3,
                    }}
                >
                    <Grid container lg={10} md={10}>
                        <Grid item lg={6} md={6} sm={12} xs={12} sx={{ p: 2 }}>
                            <Typography
                                variant="h4"
                                sx={{
                                    fontFamily: "Poppins, Arial, sans-serif",
                                    fontSize: { xs: "26px", sm: "38px", md: "45px", lg: "57px" }, // Responsive font size
                                    fontWeight: 700,
                                    color: "white",
                                    textAlign: 'start',
                                }}
                            >
                                Welcome to AMBD
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontFamily: "Poppins, Arial, sans-serif",
                                    fontSize: "18px",
                                    fontWeight: "400",
                                    color: "white",
                                }}
                            >
                                Australian Muslim Business Directory, your one click- stop to access 
                                information freely about Muslim-owned businesses, services and locations
                                across Australia.
                            </Typography>

                            <Typography
                                variant="body1"
                                sx={{
                                    fontFamily: "Poppins, Arial, sans-serif",
                                    fontSize: "18px",
                                    fontWeight: "400",
                                    color: "white",
                                    mt: 4,
                                }}
                            >
                                Please download AMBD app in your Mobile, register and start 
                                exploring the Muslim Businesses all over Australia absolutely 
                                Free of Charge
                            </Typography>

                            <Grid
                                container
                                spacing={2}
                                sx={{
                                    pb: 5,
                                    display: "flex",
                                    gap: { xs: 1, sm: 1, md: 5, lg: 5 },
                                    justifyContent: { xs: 'center', sm: 'center', md: 'start', lg: 'start' },
                                    alignItems: "center",
                                }}
                            >
                                <Grid item xs={8} sm={4} md={5} lg={5}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            ...classes.buttonStyles,
                                            width: "230px", // Ensure it takes full width on small screens
                                        }}
                                        startIcon={
                                            <Box
                                                component="img"
                                                sx={{ width: 40, height: 40, display: "inline-block" }}
                                                alt="AppStore"
                                                src={AppStore}
                                            />
                                        }
                                        onClick={() => window.open("https://apps.apple.com/pk/app/ambd/id6503895917", "_blank")}
                                    >
                                        <Box sx={classes.boxStyles}>
                                            <Typography sx={classes.typographyStylesGetItOn}>
                                                iphone app on 
                                            </Typography>
                                            <Typography sx={classes.typographyStylesGooglePlay}>
                                                App Store
                                            </Typography>
                                        </Box>
                                    </Button>
                                </Grid>
                                <Grid item xs={8} sm={4} md={5} lg={5}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            ...classes.buttonStyles,
                                            width: "230px", // Ensure it takes full width on small screens
                                        }}
                                        startIcon={
                                            <Box
                                                component="img"
                                                sx={{ height: 40, display: "inline-block" }}
                                                alt="Playstore"
                                                src={Playstore}
                                            />
                                        }
                                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ambd.ambd&pli=1", "_blank")}
                                    >
                                        <Box sx={classes.boxStyles}>
                                            <Typography sx={classes.typographyStylesGetItOn}>
                                                Android app on
                                            </Typography>
                                            <Typography sx={classes.typographyStylesGooglePlay}>
                                                Google Play
                                            </Typography>
                                        </Box>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: '100%', sm: '65%', md: '90%', lg: '80%' },
                                    // width: '100%',
                                    height: "70%",
                                    backgroundColor: "#00814E", // Semi-transparent blue background
                                    borderRadius: "100%",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    position: "relative", // Needed for absolute positioning inside
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: '320px',
                                        // height: '100%',
                                        border: '10px solid black',
                                        borderRadius: '30px',
                                        position: 'relative',  // Ensure the box positioning allows the dots to be outside
                                    }}
                                >
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            <div>
                                                <img src={screen1} className="slider-image" alt="screen1" />
                                            </div>
                                            <div>
                                                <img src={screen2} className="slider-image" alt="screen2" />
                                            </div>
                                            <div>
                                                <img src={screen3} className="slider-image" alt="screen3" />
                                            </div>
                                        </Slider>
                                    </div>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
